import { render } from "./ListItemPayment.vue?vue&type=template&id=0dc60541"
import script from "./ListItemPayment.vue?vue&type=script&lang=js"
export * from "./ListItemPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__